export default "__VITE_ASSET__1b7446a0__"